import DeliveryAreaStep from 'components/OrderSteps/DeliveryAreaStep/DeliveryAreaStep'
import Modal, { ModalRef } from 'components/common/Modal/Modal'
import { useAppSelector } from 'components/hooks/redux-selectors'
import {
  SET_SERVICE_ADDRESS_DETAILS,
  SET_SERVICE_DELIVERY_TYPE
} from 'constants/actionTypes'
import React, { RefObject } from 'react'
import { useDispatch } from 'react-redux'
import s from '../SelectServiceTimeModal/SelectServiceTimeModal.module.css'
import { DeliveryType } from 'components/common/types'

type Props = {
  modalRef: RefObject<ModalRef>
  isoCode: string
}

const SelectDeliveryAreaModal = ({ modalRef, isoCode }: Props) => {
  const destinationAddress = useAppSelector(
    (state) => state.serviceDeliveryOptions.destinationAddress
  )

  const dispatch = useDispatch()

  const handleSelectedAddressChange = (formData) => {
    dispatch({
      type: SET_SERVICE_ADDRESS_DETAILS,
      payload: formData
    })
  }

  return (
    <Modal className={s.modal} ref={modalRef}>
      <div className="flex h-full flex-col px-8 pt-20 pb-10">
        <DeliveryAreaStep
          isoCode={isoCode}
          selectedAddressDetails={destinationAddress}
          setSelectedAddressDetails={handleSelectedAddressChange}
          submitButtonText="Confirm"
          title="Delivery Address"
          showLeftArrow={false}
          coordinateBoxTextNode={
            <h3>
              Deliver to my{' '}
              <span className="text-orange-500">Current GPS location</span>
            </h3>
          }
          customSomeWhereElseTextNode={<h3>Deliver somewhere else</h3>}
          showCoordinateBox
          onSubmit={() => {
            modalRef.current?.closeModal()
            dispatch({
              type: SET_SERVICE_DELIVERY_TYPE,
              payload: DeliveryType.DELIVER
            })
          }}
        />
      </div>
    </Modal>
  )
}

export default SelectDeliveryAreaModal
